<template>
  <div class="container">
    <div style="margin-bottom: 1rem;">
      <img
        src="https://storage.googleapis.com/komerce/komtim/sk-komtim-header-hd.png"
        style="width:100%; margin-bottom: .5rem;"
      >
      <h1 class="text-center">
        SURAT KEPUTUSAN
      </h1>
      <p class="text-center">
        No : SK-XXX/KM/20XX
      </p>
    </div>
    <div class="main-content">
      <div style="padding: 0 1cm; margin-bottom: 1rem;">
        <div style="margin-bottom: 1rem;">
          <p class="text-center">
            Tentang:
          </p>
          <p class="text-center uppercase">
            <strong>{{ selectedSK.judul }}</strong>
          </p>
        </div>

        <!-- Memperhatikan dan Menimbang -->
        <table style="width:100%; border-collapse:collapse; margin-bottom:1rem;">
          <tr style="vertical-align:top;">
            <td style="width:120px;">
              Memperhatikan
            </td>
            <td style="width:15px;">
              :
            </td>
            <td>
              {{ selectedSK.memperhatikan }}</td>
          </tr>
          <tr style="vertical-align:top;">
            <td>Menimbang</td>
            <td>:</td>
            <td style="text-align:justify;">
              {{ selectedSK.menimbang }}
            </td>
          </tr>
        </table>

        <div style="margin:1rem">
          <p class="text-center">
            <strong>MEMUTUSKAN</strong>
          </p>
        </div>

        <!-- Butir Pertama dan kedua -->
        <table style="width:100%; border-collapse:collapse;">
          <tr style="vertical-align:top;">
            <td style="width:120px;">
              Menetapkan
            </td>
            <td style="width:15px;">
              :
            </td>
            <td />
          </tr>

          <tr style="vertical-align:top;">
            <td>Pertama</td>
            <td>:</td>
            <td>{{ selectedSK.menetapkan[0] }}</td>
          </tr>

          <tr style="vertical-align:top;">
            <td>Kedua</td>
            <td>:</td>
            <td>{{ selectedSK.menetapkan[1] }}</td>
          </tr>
        </table>
      </div>

      <!-- Tabel Talent Partner -->
      <table
        id="table-decision"
        style="
                width:100%;
                border-collapse:collapse;
                margin-top:.5rem;
                margin-bottom:.75rem;
                border: none;
            "
        border="1"
        cellpadding="4"
      >
        <thead>
          <tr>
            <th
              v-for="head in selectedSK.tableHeaders"
              :key="head"
            >
              {{ head }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(item, index) in data.tableItems"
            :key="index"
          >
            <td>{{ index + 1 }}</td>
            <td
              v-for="(value, indexValue) in item"
              :key="value"
              :class="{ 'text-left': indexValue === 0 }"
            >
              {{ value }}
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Butir Ketiga -->
      <div style="padding: 0 1cm;">
        <table style="width:100%; border-collapse:collapse;">
          <tr style="vertical-align:top;">
            <td style="width:120px;">
              Ketiga
            </td>
            <td style="width:15px;">
              :
            </td>
            <td>{{ selectedSK.menetapkan[2] }}</td>
          </tr>
        </table>
      </div>

      <!-- TTD -->
      <div style="margin-top:2rem; width:300px; margin-left:auto; white-space: pre;">
        <p>Ditetapkan di{{ '\t' }}: Purbalingga</p>
        <p>Pada{{ '\t\t\t\t' }}: XX XXXX 20XX</p>

        <img
          src="https://storage.googleapis.com/komerce/komtim/ttd-tri-lestari-komtim.png"
          style="width: auto; height: 100px; transform: translateX(-30%); margin: .5rem 0;"
        >

        <p><strong>Tri Lestari</strong></p>
        <p>Manager of Business Operations Komtim</p>
      </div>

      <!-- Logo Komtim -->
      <img
        src="https://storage.googleapis.com/komerce/assets/logo/logo_komtim.svg"
        class="bg-komtim"
      >
    </div>
  </div>
</template>

<style scoped>
* {
    margin: 0;
    padding: 0;
    font-family: 'Times New Roman', Times, serif;
    font-size: 12pt;
}

.container {
    width: 100%;
    max-width: 21cm;
}

.text-center {
    text-align: center;
}

#table-decision th {
    border-top: 1px solid black;
    border-bottom: 1px solid black;
    border-left: none;
    border-right: none;
    padding: .25rem;
}

#table-decision tr:not(:last-child) td {
    border: none;
}

#table-decision tr:last-child td {
    border: none;
    border-bottom: 1px solid black;
}

#table-decision tr:not(:last-child) td,
#table-decision tr:last-child td {
    padding: .25rem;
    text-align: center;
}

.main-content {
    position: relative;
    height: 100%;
    padding: 0 .5cm;
}

.bg-komtim {
    position: absolute;
    top: 25%;
    left: 50%;
    transform: translate(-50%, -25%);
    width: 50%;
    opacity: .3;
}
</style>

<script>
import { CHURN_ACTION } from '../../config'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        actionSource: '',
        tableItems: [],
      }),
    },
  },
  data() {
    return {
      skType: {
        [CHURN_ACTION.EDIT_PARTNER]: {
          judul: 'MUTASI PERALIHAN PARTNER',
          memperhatikan:
    'Kuota Talent yang berada dalam pengelolaan masing-masing Partner.',
          menimbang:
    'Sehubungan dengan kebutuhan peningkatan performa Talent serta penyesuaian kebijakan operasional yang mengharuskan adanya pergantian dan peralihan pengelolaan.',
          menetapkan: [
            'Keputusan Pimpinan Komerce mengenai Mutasi Peralihan Partner.',
            'Menetapkan perubahan dan pengalihan pengelolaan Talent sebagai berikut:',
            'Surat Keputusan ini berlaku efektif sejak tanggal ditetapkan.',
          ],
          tableHeaders: [
            'No',
            'Nama Talent',
            'ID Talent',
            'Partner Sebelumnya',
            'Partner Baru',
            'Nama Leader',
          ],
        },
        [CHURN_ACTION.EDIT_TALENT]: {
          judul: 'MUTASI PERALIHAN TALENT PARTNER',
          memperhatikan:
    'Kuota Talent yang berada dalam pengelolaan masing-masing Partner.',
          menimbang:
    'Sehubungan dengan kebutuhan peningkatan performa Talent serta penyesuaian kebijakan operasional yang mengharuskan adanya pergantian dan peralihan pengelolaan oleh Partner.',
          menetapkan: [
            'Keputusan Pimpinan Komerce mengenai Mutasi Peralihan Talent Partner.',
            'Menetapkan perubahan dan pengalihan pengelolaan Talent sebagai berikut:',
            'Surat Keputusan ini berlaku efektif sejak tanggal ditetapkan.',
          ],
          tableHeaders: [
            'No',
            'Nama Partner',
            'ID Partner',
            'Talent Sebelumnya',
            'Talent Baru',
            'Nama Leader',
          ],
        },
      },
    }
  },
  computed: {
    selectedSK() {
      return this.skType[this.data.actionSource]
    },
  },
}
</script>
